/**
 * Centralised environment variable access.
 * All components should import from here instead of reading import.meta.env directly.
 * Validated at startup in DEV mode so missing vars surface immediately with
 * a clear message pointing to the correct fix.
 */
const env = Object.freeze({
  environ: import.meta.env.VITE_ENVIRON,
  auth0Domain: import.meta.env.VITE_AUTH0_DOMAIN,
  auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  auth0Audience: 'MissionPortal-DB',
  graphqlEndpoint: import.meta.env.VITE_GRAPHQL_ENDPOINT,
  cognitoIdPool: import.meta.env.VITE_COGNITO_ID_POOL,
});

// Fail fast if any required var is missing.
// Runs in dev and test modes (import.meta.env.DEV is true for both).
// Tests pass cleanly because .env.test supplies all required values.
if (import.meta.env.DEV) {
  const missing = Object.entries(env)
    .filter(([, v]) => !v)
    .map(([k]) => k);
  if (missing.length) {
    throw new Error(
      `[env] Missing required env vars: ${missing.join(', ')}\n`
      + 'Set up your local env once: cp .env.<your-name> .env.local\n'
      + 'Then run: npm start',
    );
  }
}

export default env;
